export default [{
    label: 'Amount',
    field: 'Menge',
    isMoneyValue: false
},
{
    label: 'Total Costs',
    field: 'costs_total',
    isMoneyValue: true
},
{
    label: 'Sales Total',
    field: 'sales_total',
    isMoneyValue: true
},
{
    label: 'Arrangement fee',
    field: 'arrangement_fee',
    isMoneyValue: true
},
{
    label: 'Commission',
    field: 'commission',
    isMoneyValue: true
},
{
    label: 'Contractual commission',
    field: 'contractualCommission',
    isMoneyValue: true
},
{
    label: 'Commission (combined)',
    field: 'commissionCombined',
    isMoneyValue: true
},
{
    label: 'Agency passthrough',
    field: 'agency_value',
    isMoneyValue: true
}]